// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_auth_artifact.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "./buf/validate/validate_pb";
import type { RoomArtifactMetadata, RoomArtifactType } from "./plugnmeet_room_artifacts_pb";
import { file_plugnmeet_room_artifacts } from "./plugnmeet_room_artifacts_pb";
import type { PastRoomInfo } from "./plugnmeet_auth_room_pb";
import { file_plugnmeet_auth_room } from "./plugnmeet_auth_room_pb";
import type { StatusCode } from "./plugnmeet_common_api_pb";
import { file_plugnmeet_common_api } from "./plugnmeet_common_api_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_auth_artifact.proto.
 */
export const file_plugnmeet_auth_artifact: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_plugnmeet_room_artifacts, file_plugnmeet_auth_room, file_plugnmeet_common_api]);

/**
 * Request to fetch a list of artifacts
 *
 * @generated from message plugnmeet.FetchArtifactsReq
 */
export type FetchArtifactsReq = Message<"plugnmeet.FetchArtifactsReq"> & {
  /**
   * @generated from field: repeated string room_ids = 1;
   */
  roomIds: string[];

  /**
   * To get information about a particular session
   *
   * @generated from field: optional string room_sid = 2;
   */
  roomSid?: string | undefined;

  /**
   * @generated from field: optional plugnmeet.RoomArtifactType type = 3;
   */
  type?: RoomArtifactType | undefined;

  /**
   * @generated from field: uint64 from = 4 [jstype = JS_STRING];
   */
  from: string;

  /**
   * @generated from field: uint64 limit = 5 [jstype = JS_STRING];
   */
  limit: string;

  /**
   * @generated from field: string order_by = 6;
   */
  orderBy: string;
};

/**
 * Describes the message plugnmeet.FetchArtifactsReq.
 * Use `create(FetchArtifactsReqSchema)` to create a new message.
 */
export const FetchArtifactsReqSchema: GenMessage<FetchArtifactsReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 0);

/**
 * A single artifact entry in the list response
 *
 * @generated from message plugnmeet.ArtifactInfo
 */
export type ArtifactInfo = Message<"plugnmeet.ArtifactInfo"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: plugnmeet.RoomArtifactType type = 3;
   */
  type: RoomArtifactType;

  /**
   * @generated from field: string created = 4;
   */
  created: string;

  /**
   * @generated from field: plugnmeet.RoomArtifactMetadata metadata = 5;
   */
  metadata?: RoomArtifactMetadata | undefined;
};

/**
 * Describes the message plugnmeet.ArtifactInfo.
 * Use `create(ArtifactInfoSchema)` to create a new message.
 */
export const ArtifactInfoSchema: GenMessage<ArtifactInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 1);

/**
 * Result for fetching artifacts
 *
 * @generated from message plugnmeet.FetchArtifactsResult
 */
export type FetchArtifactsResult = Message<"plugnmeet.FetchArtifactsResult"> & {
  /**
   * @generated from field: int64 total_artifacts = 1 [jstype = JS_STRING];
   */
  totalArtifacts: string;

  /**
   * @generated from field: uint64 from = 2 [jstype = JS_STRING];
   */
  from: string;

  /**
   * @generated from field: uint64 limit = 3 [jstype = JS_STRING];
   */
  limit: string;

  /**
   * @generated from field: string order_by = 4;
   */
  orderBy: string;

  /**
   * @generated from field: optional plugnmeet.RoomArtifactType type = 5;
   */
  type?: RoomArtifactType | undefined;

  /**
   * @generated from field: repeated plugnmeet.ArtifactInfo artifacts_list = 6;
   */
  artifactsList: ArtifactInfo[];
};

/**
 * Describes the message plugnmeet.FetchArtifactsResult.
 * Use `create(FetchArtifactsResultSchema)` to create a new message.
 */
export const FetchArtifactsResultSchema: GenMessage<FetchArtifactsResult> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 2);

/**
 * Response for fetching artifacts
 *
 * @generated from message plugnmeet.FetchArtifactsRes
 */
export type FetchArtifactsRes = Message<"plugnmeet.FetchArtifactsRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: plugnmeet.FetchArtifactsResult result = 4;
   */
  result?: FetchArtifactsResult | undefined;
};

/**
 * Describes the message plugnmeet.FetchArtifactsRes.
 * Use `create(FetchArtifactsResSchema)` to create a new message.
 */
export const FetchArtifactsResSchema: GenMessage<FetchArtifactsRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 3);

/**
 * Request to get a download token for an artifact
 *
 * @generated from message plugnmeet.GetArtifactDownloadTokenReq
 */
export type GetArtifactDownloadTokenReq = Message<"plugnmeet.GetArtifactDownloadTokenReq"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;
};

/**
 * Describes the message plugnmeet.GetArtifactDownloadTokenReq.
 * Use `create(GetArtifactDownloadTokenReqSchema)` to create a new message.
 */
export const GetArtifactDownloadTokenReqSchema: GenMessage<GetArtifactDownloadTokenReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 4);

/**
 * Response for a download token
 *
 * @generated from message plugnmeet.GetArtifactDownloadTokenRes
 */
export type GetArtifactDownloadTokenRes = Message<"plugnmeet.GetArtifactDownloadTokenRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: optional string token = 4;
   */
  token?: string | undefined;
};

/**
 * Describes the message plugnmeet.GetArtifactDownloadTokenRes.
 * Use `create(GetArtifactDownloadTokenResSchema)` to create a new message.
 */
export const GetArtifactDownloadTokenResSchema: GenMessage<GetArtifactDownloadTokenRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 5);

/**
 * Request to delete an artifact
 *
 * @generated from message plugnmeet.DeleteArtifactReq
 */
export type DeleteArtifactReq = Message<"plugnmeet.DeleteArtifactReq"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;
};

/**
 * Describes the message plugnmeet.DeleteArtifactReq.
 * Use `create(DeleteArtifactReqSchema)` to create a new message.
 */
export const DeleteArtifactReqSchema: GenMessage<DeleteArtifactReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 6);

/**
 * Response for deleting an artifact
 *
 * @generated from message plugnmeet.DeleteArtifactRes
 */
export type DeleteArtifactRes = Message<"plugnmeet.DeleteArtifactRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;
};

/**
 * Describes the message plugnmeet.DeleteArtifactRes.
 * Use `create(DeleteArtifactResSchema)` to create a new message.
 */
export const DeleteArtifactResSchema: GenMessage<DeleteArtifactRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 7);

/**
 * @generated from message plugnmeet.ArtifactInfoReq
 */
export type ArtifactInfoReq = Message<"plugnmeet.ArtifactInfoReq"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;
};

/**
 * Describes the message plugnmeet.ArtifactInfoReq.
 * Use `create(ArtifactInfoReqSchema)` to create a new message.
 */
export const ArtifactInfoReqSchema: GenMessage<ArtifactInfoReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 8);

/**
 * @generated from message plugnmeet.ArtifactInfoRes
 */
export type ArtifactInfoRes = Message<"plugnmeet.ArtifactInfoRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: optional plugnmeet.ArtifactInfo artifact_info = 4;
   */
  artifactInfo?: ArtifactInfo | undefined;

  /**
   * @generated from field: optional plugnmeet.PastRoomInfo room_info = 5;
   */
  roomInfo?: PastRoomInfo | undefined;
};

/**
 * Describes the message plugnmeet.ArtifactInfoRes.
 * Use `create(ArtifactInfoResSchema)` to create a new message.
 */
export const ArtifactInfoResSchema: GenMessage<ArtifactInfoRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_artifact, 9);

